import { useContext, useEffect } from 'react'
import { FieldValues, UseFormSetValue } from 'react-hook-form'
import { CurrenciecRes } from 'shared/types/general.types'
import { StoreSettingsContext } from 'store'

type UseSetCurrencyProps = {
	currencies: CurrenciecRes | undefined
	setValue: UseFormSetValue<FieldValues>
}

export const useSetCurrency = ({ currencies, setValue }: UseSetCurrencyProps) => {
	const storeCtx = useContext(StoreSettingsContext)

	useEffect(() => {
		if (currencies?.length && storeCtx?.storeSettings?.currency) {
			setValue('currency', {
				value: storeCtx?.storeSettings?.currency,
				label: currencies?.find((currency) => currency.value === storeCtx?.storeSettings?.currency)
					?.display_name
			})
		}
	}, [currencies, storeCtx?.storeSettings?.currency])
}
